import { Chip, Paper, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";
import { tokens } from "../../../store/tokens";

const Skills = (props) => {
  const { profileDetails } = props;
  const { skill_que } = profileDetails;

  const skillList = skill_que
    ? skill_que.split(",").map((s) => s.trim()).filter(Boolean)
    : [];

  return (
    <Paper
      elevation={0}
      sx={{
        padding: `${tokens.card.padding.md}px`,
        borderRadius: `${tokens.card.radius}px`,
        border: `1px solid ${tokens.color.line}`,
        bgcolor: tokens.color.surface,
      }}
    >
      <Stack spacing={1.5}>
        <Typography variant="subtitle1" sx={{ color: tokens.color.ink }}>
          Skills
        </Typography>

        {skillList.length === 0 ? (
          <Typography variant="body2" sx={{ color: tokens.color.inkFaint }}>
            No skills listed yet.
          </Typography>
        ) : (
          <Stack direction={"row"} spacing={1} sx={{ flexWrap: "wrap", gap: 1 }}>
            {/* Chip, not Button — these are descriptive tags, not actions,
                so a button (with its click affordance) was the wrong
                element even before the missing `key` prop below. */}
            {skillList.map((skill) => (
              <Chip
                key={skill}
                label={skill}
                size="small"
                variant="outlined"
                sx={{
                  fontSize: "0.75rem",
                  fontWeight: 500,
                  color: tokens.color.tealDark,
                  borderColor: tokens.color.teal,
                  bgcolor: tokens.color.tealLight,
                }}
              />
            ))}
          </Stack>
        )}
      </Stack>
    </Paper>
  );
};

export default Skills;
